import Vue from 'vue';
import Vuex from 'vuex'
import user from './modules/user'
import project from './modules/project'
import task from './modules/task'
import common from './modules/common'
import timesheet from './modules/timesheet'
Vue.use(Vuex)
const store = new Vuex.Store({
    namespaced: true,
    state: {
      loading: false,
      showBanner: false,
      ganttRender: false,
      showFeatured: true,
    },
  
    mutations : {
      setLoading : (state, payload) => {
        state.loading = payload
      },
      setShowBanner : (state, payload) => {
        state.showBanner = payload
      },
      setGanttRender : (state) => {
        state.ganttRender = !state.ganttRender
      },
      setShowFeatured : (state) => {
        state.showFeatured = !state.showFeatured
      }
    },
  
    actions: {
      
    },
  
    modules: {
      user,
      project,
      task,
      common,
      timesheet
    }
  })

export default store